import { render, staticRenderFns } from "./IconSettingsInfo.vue?vue&type=template&id=3060f992&"
import script from "./IconSettingsInfo.vue?vue&type=script&lang=js&"
export * from "./IconSettingsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3060f992')) {
      api.createRecord('3060f992', component.options)
    } else {
      api.reload('3060f992', component.options)
    }
    module.hot.accept("./IconSettingsInfo.vue?vue&type=template&id=3060f992&", function () {
      api.rerender('3060f992', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconSettingsInfo.vue"
export default component.exports